import { ISpinResponse } from '@/modules'
import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { Utilities } from '@base/utils/Utilities'
import Facade from '@/Facade'

export class GetSpinResponseState extends BaseState {
    private static readonly DEBUG_PREFIX = '[DBG:GetSpinResponseState]'
    public begin() {
        this.beginNormalSpin()
    }

    private beginNormalSpin() {
        GameSignals.spinResponse.connect(this.end)

        const isBuyBonusSpin = !!this._model.isBuyBonusPending
        const search = new URLSearchParams(window.location.search)
        const gameId = Number(search.get('game_id') || search.get('gameId') || 1406)
        const initBonusGameId = Number((this._model.initData as any)?.bonus_game_id)
        const bonusGameId =
            Number.isFinite(initBonusGameId) && initBonusGameId > 0 ? initBonusGameId : Number(`${gameId}003`)

        GameSignals.getSpinResponse.emit({
            sessionToken: '',
            amount: this._model.fixedCoinsBet,
            coinValue: this._model.currentCoinBet,
            requestType: isBuyBonusSpin ? 6 : 2,
            pickPosition: isBuyBonusSpin ? this._model.buyBonusPickPosition : undefined,
            bonusGameId: isBuyBonusSpin ? bonusGameId : undefined,
        })
    }

    public end = (data: ISpinResponse) => {
        console.log(`${GetSpinResponseState.DEBUG_PREFIX} end(data) incoming`, {
            win_currency: data?.win_currency,
            base_win_currency: data?.base_win_currency,
            freebet: data?.freebet,
            bonus: data?.bonus,
            winning_combinations_len: Array.isArray(data?.winning_combinations)
                ? data.winning_combinations.length
                : 'n/a',
        })

        this._model.spinData = data
        this._model.isBuyBonusPending = false
        this._model.buyBonusPickPosition = 0
        this._model.bonusBuyBet = null

        const { freeround } = this._model.spinData

        !!freeround && freeround.amount_left === 0 && Utilities.isLocalStorageAvailable()
            ? localStorage.setItem(`${Facade.urlParams.playerUid}_freeround`, JSON.stringify(freeround))
            : localStorage.removeItem(`${Facade.urlParams.playerUid}_freeround`)

        console.log(`${GetSpinResponseState.DEBUG_PREFIX} model.spinData committed`, {
            win_currency: this._model.spinData?.win_currency,
            base_win_currency: this._model.spinData?.base_win_currency,
            freebet: this._model.spinData?.freebet,
            bonus: this._model.spinData?.bonus,
        })

        this._stateMachine.setState(GameStatesEnum.STOP_SPIN_STATE)
    }

    public cleanUp() {
        GameSignals.spinResponse.disconnect(this.end)
    }
}
